var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('div',{key:"skeleton",staticClass:"w-100"},[_vm._t("skeleton")],2):_c('div',{key:"component",staticClass:"w-100"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }